import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import BaseModal from '../../Modal/BaseModal';
import { StyledDataGrid } from '../../DataGrid/DataGridStyles';
import { AutosizeColumnsToggle } from '../../DataGrid/AutosizeColumnsToggle';
import { SearchBar } from '../../SearchBar/SearchBar';
import { ShowFeedModalProps } from './types';
import { useShowFeedModal } from './useShowFeedModal';
import styles from './ShowFeedModal.module.scss';

export const ShowFeedModal: React.FC<ShowFeedModalProps> = ({
  open,
  onClose,
  filterBy,
}) => {
  const {
    rows,
    totalRowCount,
    columns,
    isLoading,
    autosizeColumns,
    setAutosizeColumns,
    apiRef,
    isRowDisabled,
    searchTerm,
    handleSearch,
  } = useShowFeedModal(filterBy);

  const renderContent = () => {
    if (isLoading) {
      return (
        <Box className={styles.emptyState}>
          <CircularProgress />
        </Box>
      );
    }

    if (totalRowCount === 0) {
      return <Box className={styles.emptyState}>No data available</Box>;
    }

    return (
      <>
        <Box className={styles.controlsRow}>
          <SearchBar
            onSearch={handleSearch}
            value={searchTerm}
            placeholder="Search rows..."
          />
          <AutosizeColumnsToggle
            checked={autosizeColumns}
            onChange={setAutosizeColumns}
          />
        </Box>
        <Box className={styles.gridContainer}>
          <StyledDataGrid
            apiRef={apiRef}
            rows={rows}
            columns={columns}
            getRowId={row => row._row_index}
            loading={isLoading}
            checkboxSelection={false}
            disableRowSelectionOnClick
            enableClipboard={false}
            enableExport={false}
            getRowClassName={params =>
              isRowDisabled(params.row) ? styles.disabledRow : ''
            }
          />
        </Box>
      </>
    );
  };

  return (
    <BaseModal
      dataTestId="show-feed-modal"
      open={open}
      onClose={onClose}
      title={`Data Feed Preview${filterBy?.symbol ? ` — ${filterBy.symbol}` : filterBy?.isin ? ` — ${filterBy.isin}` : ''}`}
      maxWidth="xl"
      fullWidth={true}
      hideSubmit={true}
      hideCancel={true}
    >
      {renderContent()}
    </BaseModal>
  );
};
